import {USER_DATA_REQUEST, USER_DATA_SUCCESS, USER_DATA_FAILURE} from '../constants';

export const userDataRequest = (userId) => ({
  type: USER_DATA_REQUEST,
  payload: { userId },
});

export const userDataSuccess = (data) => ({
  type: USER_DATA_SUCCESS,
  payload: data,
});

export const userDataFailure = (error) => ({
  type: USER_DATA_FAILURE,
  payload: error,
});